import { render, staticRenderFns } from "./QuizStudent.vue?vue&type=template&id=60e938c2&scoped=true"
import script from "./QuizStudent.vue?vue&type=script&lang=js"
export * from "./QuizStudent.vue?vue&type=script&lang=js"
import style0 from "./QuizStudent.vue?vue&type=style&index=0&id=60e938c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e938c2",
  null
  
)

export default component.exports